var ReactRedux = require('react-redux');
var Reselect = require('reselect');

var courierActions = require('../../../actions/courierActions');
var CouriersPresentational = require('../../../components/Admin/Couriers/Couriers.jsx');

var { createSelector } = Reselect;

export function getCouriers(state) {
	return state.couriers;
};

export function getCourierList(state) {
	return getCouriers(state).list;
};

var mapStateToProps = function(state) {
	return createSelector (
		getCourierList,
		(couriers) => ({
			couriers
		})
	);
};

var mapDispatchToProps = function(dispatch) {
	return {
		load: function() {
			dispatch(courierActions.loadCouriers());
		},

		unload: function() {
			dispatch(courierActions.unsubscribe());
		}
	};
};

module.exports = ReactRedux.connect(
	mapStateToProps, mapDispatchToProps
)(CouriersPresentational);


// WEBPACK FOOTER //
// ./src/containers/Admin/Couriers/Couriers.js